// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"12":"profiler","777":"recorder"}[chunkId] || chunkId) + "." + {"12":"f91c23ae","453":"749dd1c3","777":"34be3623"}[chunkId] + ".chunk.js";
};